const axios = require('axios')

const readJsonFileUriSync = function(uri, file, next) {
    axios.get(uri + file).then(next)
}

const isPromiseForObjects = function(objects, readyCalback) {
    let _isPromise = isPromise
    let resultArray = []

    let keys = Object.keys(objects)

    let pushDoneElement = (_element) => {
        resultArray.push(_element)

        if (resultArray.length == array.length) {
            readyCalback(resultArray)
            return
        }
    }

    keys.forEach((key) => {
        let element = objects[key]

        let isPromiseCheck = _isPromise(element)

        if (isPromiseCheck == true) {
            element.then((_element) => {
                pushDoneElement(_element)
            })
        }
        else {
            pushDoneElement(element)
        }
    })
}

const isPromise = function(obj) {
    if(Promise && Promise.resolve){
      return Promise.resolve(obj) == obj;
    }
    else {
      throw "Promise not supported in your environment"
    }
}

const isAlreadyUrl = (src) => src.startsWith('http') == true || src.startsWith('//') == true;

const hasValue = function(data) {
    if (!data) return false

    if (data == undefined) return false

    if (data == null) return false

    return true
}

const getObserveValue = (observeData) => {
    return JSON.parse(JSON.stringify(observeData))
}

// module.exports = {
//     'readJsonFileUriSync': readJsonFileUriSync,
//     'isPromise': isPromise,
//     'hasValue': hasValue,
// }
export default {
    'readJsonFileUriSync': readJsonFileUriSync,
    'isPromise': isPromise,
    'hasValue': hasValue,
    'isPromiseForObjects': isPromiseForObjects,
    'isAlreadyUrl': isAlreadyUrl,
    'getObserveValue': getObserveValue,
}



// WEBPACK FOOTER //
// ./src/utils.js